import { Bell } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useCommissionRequestsCount } from '@/hooks/useCommissionRequestsCount';
import { useNavigate } from 'react-router-dom';

export const CommissionRequestsBadge = () => {
  const { totalPendingRequests, requestsByCommission, loading } = useCommissionRequestsCount();
  const navigate = useNavigate();

  if (loading || totalPendingRequests === 0) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="relative">
          <Bell className="h-5 w-5" />
          {totalPendingRequests > 0 && (
            <Badge 
              variant="destructive" 
              className="absolute -top-1 -right-1 h-5 w-5 flex items-center justify-center p-0 text-xs animate-pulse"
            >
              {totalPendingRequests > 9 ? '9+' : totalPendingRequests}
            </Badge>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80">
        <DropdownMenuLabel>
          Demandes d'adhésion en attente
          <span className="ml-2 text-xs text-muted-foreground">
            ({totalPendingRequests})
          </span>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        
        {requestsByCommission.map((commission) => (
          <DropdownMenuItem
            key={commission.commissionId}
            onClick={() => navigate('/admin/commissions')}
            className="cursor-pointer"
          >
            <div className="flex items-center justify-between w-full">
              <span className="font-medium">{commission.commissionName}</span>
              <Badge variant="secondary" className="ml-2">
                {commission.count}
              </Badge>
            </div>
          </DropdownMenuItem>
        ))}
        
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={() => navigate('/admin/commissions')}
          className="cursor-pointer text-center justify-center font-medium"
        >
          Voir toutes les demandes
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
